import { Node, mergeAttributes } from "@tiptap/core";

export interface BlockThreadAttributes {
  "data-thread-id": string;
}

export const BlockThread = Node.create({
  name: "blockThread",
  group: "block",
  content: "block+",

  addAttributes() {
    return {
      "data-thread-id": {
        default: "",
        parseHTML: (element) => element.getAttribute("data-thread-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-thread-id"]) {
            return {};
          }
          return {
            "data-thread-id": attributes["data-thread-id"],
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-block-thread]",
        getAttrs: (node) => {
          if (!(node instanceof HTMLElement)) return false;
          return {
            "data-thread-id": node.getAttribute("data-thread-id"),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-block-thread": "",
      }),
      0,
    ];
  },
});
